import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CompanyPageStepLicenseJobboardsComponent } from './company-page-step-license-jobboards.component';

@NgModule({
  declarations: [CompanyPageStepLicenseJobboardsComponent],
  imports: [CommonModule, FormsModule],
  exports: [CompanyPageStepLicenseJobboardsComponent],
  entryComponents: [CompanyPageStepLicenseJobboardsComponent]
})
export class CompanyPageStepLicenseJobboardsModule { }
